import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetClassification,
  resetClassificationHistory,
  setClassificationError,
} from "../../../ducks/classification/classification";
import { getSelectedSegment } from "../../../ducks/style/selectors";

export const useClassificationReset = (): VoidFunction => {
  const dispatch = useDispatch();
  const selectedSegment = useSelector(getSelectedSegment);

  return useCallback(() => {
    dispatch(setClassificationError(null));

    if (selectedSegment === undefined) {
      dispatch(resetClassification());
      dispatch(resetClassificationHistory());
    }
  }, [dispatch, selectedSegment]);
};
